import React from 'react'

export default () => (
    <div style={{
        height: '100vh',
        backgroundImage: 'url(http://i.giphy.com/8L0Pky6C83SzkzU55a.gif)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }}>
    </div>
)






// WEBPACK FOOTER //
// ./src/views/custom/Page404/Page404.js